module.exports = __webpack_public_path__ + "img/blogger-b.262699c4.svg";